import MultiLanguageWebsiteRenderer from "@/components/MultiLanguageWebsiteRenderer";

const Index = () => {
  return <MultiLanguageWebsiteRenderer pageId="home" />;
};

export default Index;